import './bootstrap';

// Externals
import '@wwdev/bootstrap/index.js';
import './wwdev/forms/index';
import '@fancyapps/fancybox';
import './wwdev/lazysizes/index.js';
import './wwdev/webshop/index.js';
import '@wwdev/myaccount/index.js';
import '@wwdev/register';
import '@wwdev/search';
import '@wwdev/functions/setEqualHeightsPerRow';
import './externals/hamburgers.js';

import WOW from 'wow.js';
new WOW().init();
import './externals/flickity';

// Base
import './base/menu';
import './base/NumberInput';
import './base/cookiebar';
import './base/popup';

// Sections
import './sections/Fullscreen';

// Vendors
import Item from './vendor/product/item';
new Item();
import './vendor/Search/searchForm';
import './vendor/winkelwagen/Checkout'
import './vendor/my-account/orders'
import './vendor/kennisbank/grid';
import './base/toggleMenuItem.js';


$(document).ready(function() {
	$("form.inputform").validate({
		lang: 'nl'  // or whatever language option you have.
	});
});